import { capitalize, lowercase } from "../../../../../utils/stringUtils";
export var getQuestIcon = function (iconName) {
    return capitalize(iconName) + "Icn";
};
export var getQuestProfile = function (profileName) {
    return "profile_image sprite-profiles-large profiles-large-" + lowercase(profileName).replace("Icn", "");
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/quest/list/tasks/getQuestIcon.ts
// module id = 311
// module chunks = 3